import { ReviewSearchParamsDto, convertReviewSearchDtoToSearchParamsArray } from '@/contracts/marketplace/reviews';
import { BrandGroupEntity } from '@/entities/brand-group.entity';
import { ProductGroupEntity } from '@/entities/product-group.entity';
import { ReviewEntity } from '@/entities/review.entity';
import { Sort } from '@/types/sort.type';
import {
    AiSelectedAnalysisProgress,
    ReviewsAutoReplyProgress,
    ReviewsExportProgress,
} from '@/context/reviews-page.types';
import { normalizeReviewFilters } from '@/shared/review-filters-normalization';

type InitialStateInput = {
    totalReviews: number;
    reviews: ReviewEntity[];
    products: ProductGroupEntity[];
    brandGroups: BrandGroupEntity[];
    filters: ReviewSearchParamsDto;
    reviewsOnPage: number;
};

export type ReviewsPageState = {
    selectionSessionId: string;
    pickedReviews: string[];
    pickedProducts: string[];
    pickedBrandGroups: string[];
    reviews: ReviewEntity[];
    products: ProductGroupEntity[];
    brandGroups: BrandGroupEntity[];
    total: number;
    sort: Sort;
    filters: ReviewSearchParamsDto;
    filtersQuery: string[];
    reviewsOnPage: number;
    aiAnalysisProgress: AiSelectedAnalysisProgress | null;
    exportProgress: ReviewsExportProgress | null;
    autoReplyProgress: ReviewsAutoReplyProgress | null;
    selectionReconcileRevision: number;
};

export const createInitialReviewsPageState = ({
    totalReviews,
    reviews,
    products,
    brandGroups,
    filters,
    reviewsOnPage,
}: InitialStateInput): ReviewsPageState => {
    const normalizedFilters = normalizeReviewFilters(filters);

    return {
        selectionSessionId: '',
        pickedReviews: [],
        pickedProducts: [],
        pickedBrandGroups: [],
        reviews,
        products,
        brandGroups,
        total: totalReviews,
        sort: {},
        filters: normalizedFilters,
        filtersQuery: convertReviewSearchDtoToSearchParamsArray(normalizedFilters),
        reviewsOnPage,
        aiAnalysisProgress: null,
        exportProgress: null,
        autoReplyProgress: null,
        selectionReconcileRevision: 0,
    };
};
